import { useState, useEffect } from "react";
import CustomSwitch from "../../../components/CustomSwitch";
import { useSelector, useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { toggleRankAOnly, getTypeOfTalent, setSelectedTypeOfTalent } from "../../../reducers/companyHome";
import Dropdown from "../../../components/Dropdown";
import { TALENT_TYPE_OPTION_TYPE } from "../../../constants/index";

const CompanyHomeHeader = () => {
  const rankAOnly = useSelector((state: any) => state.companyHome.rankAOnly);
  const { typeOfTalent, selectedTypeOfTalent } = useSelector((state: any) => state.companyHome);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    dispatch(getTypeOfTalent({option: TALENT_TYPE_OPTION_TYPE}));
  }, []);

  const handleToggleRankAOnly = () => {
    dispatch(toggleRankAOnly());
  };
  
  return (
    <div className="mb-4 flex items-center gap-10">
      <h1 className="text-xl font-bold leading-[1.875rem] alu-text-base-2">
      ダッシュボード
      </h1>
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-[0.4375rem]">
          <Dropdown
            inputWidth="full"
            placeholder="すべて表示" 
            customStyle="shrink-0 min-w-[10rem]"
            fontWeight="bold"
            options={typeOfTalent}
            value={selectedTypeOfTalent} 
            onChange={(value: any) => dispatch(setSelectedTypeOfTalent(value))} 
          />
        </div>
        <div className="flex items-center gap-[0.4375rem]">
          <p onClick={() => handleToggleRankAOnly()} className="text-sm alu-text-base-2 font-bold cursor-pointer">
            採用ランクAのみ表示
          </p>
          <CustomSwitch
            checked={rankAOnly}
            onChange={() => handleToggleRankAOnly()}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyHomeHeader;